import { content as en } from "@/content/en";
import { content as it } from "@/content/it";
import { content as de } from "@/content/de";
import { content as nl } from "@/content/nl";

export const locales = { en, it, de, nl };

export const LOCALE_ORDER = ["en", "it", "de", "nl"];

export const STORAGE_KEY = "lojack_lang";

// Detect the best matching locale from the browser, falling back to English.
export function detectLocale() {
  const stored =
    typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
  if (stored && locales[stored]) return stored;

  const langs =
    (typeof navigator !== "undefined" &&
      (navigator.languages || [navigator.language])) ||
    [];
  for (const l of langs) {
    const code = String(l).slice(0, 2).toLowerCase();
    if (locales[code]) return code;
  }
  return "en";
}

export function getContent(locale) {
  return locales[locale] || en;
}

export function buildToc(c) {
  return [
    { id: c.preamble.id, label: c.preamble.title },
    ...c.articles.map((a) => ({ id: a.id, label: `${a.number} — ${a.title}` })),
    ...c.annexes.map((a) => ({ id: a.id, label: `${a.number} — ${a.title}` })),
  ];
}
